jQuery(document).ready(function ($) {
	var breakpoint_small = 0;
	var breakpoint_medium = 640;
	var breakpoint_large = 1024;
	var breakpoint_xlarge = 1200;
	var breakpoint_xxlarge = 1440;

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											FACTS & FIGURES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// facts-figures-01
	// http://aishek.github.io/jquery-animateNumber/
	$('section.facts-figures-01 [data-number]').each(function () {
		var animate_number = String($(this).data('number'));
		var comma_separator_number_step = $.animateNumber.numberStepFactories.separator('.');

		// If the number has a , (decimal) also animate the decimals
		if (animate_number.indexOf(",") !== -1) {
			var number_parts = animate_number.split(",");
			var decimal_places = number_parts[1].length;

			var decimal_factor = decimal_places === 0 ? 1 : Math.pow(10, decimal_places);

			// Replace , for .
			animate_number = parseInt(animate_number.replace(",", ".") * decimal_factor);

			$(this).animateNumber({
				number: animate_number,
				easing: 'easeOutQuad',
				numberStep: function (now, tween) {
					var floored_number = Math.floor(now) / decimal_factor;
					var target = $(tween.elem);

					if (decimal_places > 0) {
						// force decimal places even if they are 0
						floored_number = floored_number.toFixed(decimal_places);

						// replace '.' separator with ','
						floored_number = floored_number.toString().replace('.', ',');
					}

					target.text(floored_number);
				}
			},
				3000);
		}
		else {
			// animate non-decimal numbers. Use dot . for 1000-separator for large numbers
			$(this).animateNumber({
				number: animate_number,
				easing: 'easeOutQuad',
				numberStep: comma_separator_number_step
			},
				3000);
		}
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											GOOGLE MAPS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// For all google maps:

	// Removes the invisible layer on the Google Map on click
	$('.google-map-overlay').on('click', function () {
		$(this).removeClass('google-map-overlay');
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											TESTIMONIALS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// testimonials-01
	// Create a slider from Dynamic Content Columns, only if there are more than 3 columns
	//	if (jQuery(".testimonial-01 .testimonials .testimonial").length > 2)
	//	{
	//		jQuery(".testimonial-01 .testimonials").slick({
	//			infinite: false,
	//			slidesToShow: 1,
	//			slidesToScroll: 1
	//		});
	//	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//												SLIDERS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// Create a slider from div.lite-slide elements, only if there are more than 1 items.
	// Ondersteunt 2 varianten via het optionele data-slider-variant-attribuut:
	// - (geen attribuut, standaard) normale .lite-slider: dots, geen centerMode, 2 breakpoints
	// - "overflow" (content-14): kaarten die deels buiten beeld steken (centerMode + padding),
	//   eigen rand-pijl-disable-logica i.p.v. dots, 1 breakpoint. Was voorheen een losse,
	//   dedicated init in lite-child.js (Fase 1f, JS-consolidatie) — nu samengevoegd tot deze ene
	//   configureerbare module.
	if (jQuery(".lite-slider .lite-slide").length > 1) {
		jQuery(".lite-slider").each(function () {
			var $slider          = jQuery(this);
			var slider_variant   = $slider.data('slider-variant');
			var slides_to_show   = parseInt($slider.data('slides-to-show')) || 1;
			var slides_to_scroll = parseInt($slider.data('slides-to-scroll')) || 1;
			var initial_slide    = parseInt($slider.data('initial-slide')) || 0;

			var config;

			if (slider_variant === 'overflow') {
				config = {
					arrows: true,
					infinite: false,
					slidesToScroll: slides_to_scroll,
					slidesToShow: slides_to_show,
					accessibility: true,
					variableWidth: false,
					focusOnSelect: false,
					initialSlide: initial_slide,
					centerMode: true,
					centerPadding: '60px',
					responsive: [
						{
							breakpoint: breakpoint_medium,
							settings: {
								initialSlide: 0,
								slidesToScroll: 1,
								slidesToShow: 1
							}
						}
					]
				};
			}
			else {
				// Default
				var slides_to_show_small = parseInt($slider.data('slides-to-show-small')) || 1;
				var slides_to_show_medium = 3;

				config = {
					infinite: false,
					slidesToShow: slides_to_show,
					slidesToScroll: slides_to_scroll,
					dots: true,
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: breakpoint_large,
							settings: {
								slidesToShow: slides_to_show_medium,
								dots: true
							}
						},
						{
							breakpoint: breakpoint_medium,
							settings: {
								slidesToShow: slides_to_show_small,
								arrows: false,
								centerMode: true
							}
						}
					]
				};
			}

			$slider.not('.slick-initialized').slick(config);

			if (slider_variant === 'overflow') {
				// Zet de rand-pijlen op "disabled" bij de eerste/laatste slide i.p.v. de
				// standaard dots-navigatie (die deze variant bewust niet gebruikt).
				$slider.on('init reInit afterChange', function (event, slick, currentSlide) {
					var slideCount = slick.slideCount;
					var current = (currentSlide != null) ? currentSlide : 0; // fallback voor 'init'

					if (current <= 1) {
						$slider.find('.slick-prev').addClass('slick-disabled').attr('aria-disabled', 'true');
					}
					else {
						$slider.find('.slick-prev').removeClass('slick-disabled').attr('aria-disabled', 'false');
					}

					if (current >= slideCount - 2) {
						$slider.find('.slick-next').addClass('slick-disabled').attr('aria-disabled', 'true');
					}
					else {
						$slider.find('.slick-next').removeClass('slick-disabled').attr('aria-disabled', 'false');
					}
				});
			}
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-03 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	if (jQuery(".header-03 .header-images .header-img").length > 1) {
		$('.header-03 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 4000
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-04 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////

	if (jQuery(".header-04 .header-images .header-img").length > 1) {
		$('.header-04 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 4000
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									VIDEO-HEADER-01 BG VIDEO
	/////////////////////////////////////////////////////////////////////////////////////////////////


	// jQuery is required to run this code
	scaleVideoContainer();

	initBannerVideoSize('.coverr-video-container video');

	$(window).on('resize', function () {
		scaleVideoContainer();
		scaleBannerVideoSize('.coverr-video-container video');
	});
});

function scaleVideoContainer() {
	var height = $(window).height() + 5;
	var unitHeight = parseInt(height) + 'px';
	$('.homepage-hero-module').css('height', unitHeight);
}

function initBannerVideoSize(element) {
	$(element).each(function () {
		$(this).data('height', $(this).height());
		$(this).data('width', $(this).width());
	});

	scaleBannerVideoSize(element);
}

function scaleBannerVideoSize(element) {

	var windowWidth = $(window).width(),
		windowHeight = $(window).height() + 5,
		videoWidth,
		videoHeight;

	$(element).each(function () {
		var videoAspectRatio = $(this).data('height') / $(this).data('width');

		$(this).width(windowWidth);

		if (windowWidth < 1000) {
			videoHeight = windowHeight;
			videoWidth = videoHeight / videoAspectRatio;
			$(this).css({ 'margin-top': 0, 'margin-left': -(videoWidth - windowWidth) / 2 + 'px' });

			$(this).width(videoWidth).height(videoHeight);
		}

		$('.homepage-hero-module .coverr-video-container video').addClass('fadeIn animated');

	});
}
